import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

function Instructions({title}) {

    useEffect(() => {
        document.title = title;
    }, [title]);

    return (
      <>
        <div className='instructions_section'>
            <div className="instructions_wrapper">
                <h2 className='instructions_title'>
                    Instructions for Authors
                </h2>

                <hr class="instructions_hr"/>

                <p className='instructions_p'>

                    <i>Annals of Nursing</i> provides extensive coverage of all areas of nursing practice, including hospital, family, and community settings. All articles published in the journal are openly accessible to internet users and may be used for commercial purposes. The journal emphasizes the vital role of nurses and medical technicians in promoting health and quality of life, preventing disease, providing care for individuals with illnesses or disabilities, and supporting rehabilitation following illnesses.
                    
                    <br/><br/><br/>

                    <i>Annals of Nursing</i> adheres strictly to the <strong>Code of Conduct</strong> and <strong>Best Practice Guidelines</strong> established by the <i>Committee on Publication Ethics (COPE)</i>. The editors of <i>Annals of Nursing</i> are committed to maintaining high scientific and academic standards by ensuring a thorough peer-review process and enforcing strict ethical policies in scholarly publishing. In the event of any ethical concerns, appropriate measures are promptly undertaken. Any ethical issues raised by readers are carefully reviewed by the editorial office in accordance with COPE procedures.

                    <br/><br/><br/>
                    The submitted manuscript must not be under consideration for publication in any other journal nor may it be already published in extenso or partly.
                    <br/><br/><br/>
                    There is no publication charge for authors in the Annals of Nursing.
                    <br/><br/><br/>
                    All papers are checked for plagiarism before being sent for peer review.
                    <br/><br/><br/>
                    Annals of Nursing publishes <strong className='instructions_bold'>Original Articles, Reviews, Case Reports, Letters to the Editor, Short Communications, Commentaries, Book Reviews, Professional Papers, and Editorials.</strong>
                    <br/><br/><br/>
                    The peer review is double blind with up to three reviewers.
                    <br/><br/><br/>
                    The rights of the examinees must be protected by mandatory <strong>Informed Consent</strong>. Patients’ names must not appear in any part of the paper.
                    <br/><br/><br/>
                    If applicable the manuscript should contain the Decision of the Ethics Committee concerning the study.
                    <br/><br/><br/>
                    If any <strong>Conflict of Interest</strong> exists the authors must make a detailed statement in the manuscript before the list of references. If there is no conflict of interest the authors should state „ The authors declare no conflict of interest“.
                    <br/><br/><br/>
                    Each author must have made a significant contribution to the study—whether through conceiving or designing the research, collecting, analyzing, or interpreting data, drafting or critically revising the manuscript for important intellectual content, and/or giving final approval of the version to be published.
                    <br/><br/><br/>
                    <i>Annals of Nursing</i> does not permit listing <strong>AI tools</strong> as authors and requires authors to clearly disclose any non-basic use of artificial intelligence. Responsibility for the content rests entirely with the authors, who must ensure that all AI-generated material is accurate and verifiable. In most cases, the journal also forbids the inclusion of AI-created images or references. Any use of AI should be explicitly mentioned in the appropriate section of the manuscripts such as the acknowledgments or methods—to uphold the transparency and integrity of the research.
                    <br/><br/><br/>
                    Please consult the <strong>Equator guidelines</strong> for the good practice in scientific writing (<a href="https://www.equator-network.org/reporting-guidelines" target='_blank' rel="noreferrer" className='instructions_link'>https://www.equator-network.org/reporting-guidelines</a>).
                </p>


                <h2 className='instructions_title'>
                    Manuscript submission
                </h2>

                <hr class="instructions_hr"/>

                <p className='instructions_p ins_above_ul'>
                    The papers should be submitted online through the journal website.
                    <br/><br/><br/>
                    All manuscript pages must be numbered, starting from the front page. Use the Times Roman font 12, with left justification and double space. The maximum size of a paper (words), excluding tables and figures and references, depends on the type of submission: Original Article – 3500, Review – 5000, Case Report – 1500, Short Communication - 1500, Letter to the Editor – 500, Commentary – 500, Professional Paper-1500 The number of tables and figures is limited to five and three, respectively.
                    <br/><br/><br/>
                    <strong className='instructions_bold'>Cover Letter</strong> should contain a statement that all co-authors have approved the content and submission of the paper and specify the role of each co-author in preparing the manuscript. The corresponding author should make a statement about the conflict of interest. It should be stated that the manuscript has not been published nor is under consideration for publication elsewhere. The corresponding author should also explain why he/she thinks the paper should be published in the Annals of Nursing.
                    <br/><br/><br/>
                    <strong className='instructions_bold'>The front page</strong> contains the article title, the authors' full names, the authors' affiliations, word count, the number of tables, the number of figures, and the full name, email address and telephone of the corresponding author.
                    <br/><br/><br/>
                    <strong className='instructions_bold'>Abstract</strong> should have a size of up to 250 words, in a structured form, with subheadings: Background, Aim, Materials and Methods, Results and Conclusion. The abstract of a narrative review should be written in one paragraph and in an unstructured form.
                    
                    <br/><br/><br/>
                    From 3-5 <strong>Keywords</strong> follow the abstract.
                    <br/><br/><br/>
                    <strong>Corresponding Author’s</strong> name and e-mail address follow keywords. Please provide three <strong>Key Messages</strong> of your paper, each not exceeding 100 characters (excluding spaces).

                    <br/><br/><br/>
                    <strong className='instructions_bold'>Manuscript</strong> should be organized in six segments: Introduction, Materials and Methods, Results, Discussion, Acknowledgments and References.
                    <br/><br/><br/>


                    <strong className='instructions_bold'>References</strong>
                    <br/><br/>

                    Please do not cite abstracts, unpublished material, commentaries and newspaper articles.
                    
                    <br/><br/>

                    The ICMJE (<a href="https://www.icmje.org/" target='_blank' rel="noreferrer" className='instructions_link'>www.icmje.org</a>) system is adopted, whereby references in the reference list at the
                    end of the manuscript should be numbered consecutively in the order in which they are first
                    mentioned in the text (not in alphabetic order). Please use the standard ISO4 abbreviations for
                    the journal names. Where available, please provide DOI for the references. If there are up to six
                    authors mention them all. If there are more than six authors mention just the first three authors
                    followed by “et al.”
                    
                    <br/><br/>
                    
                    Here are the examples of citing:

                    <br/><br/>

                    <strong className='instructions_bold'>Papers:</strong>
                    <br/><br/>

                    Croxon L, Maginnis C.  Evaluation of clinical teaching models for nursing practice. Nurse Educ
                    Pract 2009; 9(4): 236–243.

                    <br/><br/><br/>

                    <strong className='instructions_bold'>Books:</strong>
                    <br/><br/>

                    Schreier M. Qualitative content analysis in practice. London: Sage; 2012.

                    <br/><br/><br/>

                    <strong className='instructions_bold'>Book Chapters:</strong>
                    <br/><br/>

                    Baldwin ML, Johnson WG. A critical review of studies of discrimination against workers with
                    disabilities. In: Rodgers WM (Ed.) Handbook on the Economics of Discrimination. Edward
                    Elgar Publishing, 2006; pp. 119-160.

                    <br/><br/><br/>

                    <strong className='instructions_bold'>Conference Papers:</strong>
                    <br/><br/>

                    Fields JM, de Jong RG, Flindell IH, et al. Recommendation for shared annoyance questions in
                    noise annoyance surveys. In: Carter N, Job SRF. (eds.) Noise Effects ‘98. Proceedings of the 7th
                    International Congress on Noise as a Public Health Problem. Sydney, Australia: Noise Effects
                    PTY Ltd.; 1998. Vol 1; p. 481-486.

                    <br/><br/><br/>


                    <strong className='instructions_bold'>Internet Sites:</strong>
                    <br/><br/>

                    World Health Organization. Access to rehabilitation in primary health care: an ongoing
                    challenge. World Health Organization. 2018.
                    <br/><br/>
                    Available at: https://iris.who.int/handle/1066 5/325522. Last Access on November 15, 2024.

                    <br/><br/><br/>

                    <strong className='instructions_bold'>Dissertation:</strong>
                    <br/><br/>

                    Liu-Ambrose TY. Studies of fall risk and bone morphology in older women with low bone mass
                    [dissertation]. [Vancouver (BC)]: University of British Columbia; 2004. 290 p.

                    <br/><br/><br/>

                    <strong className='instructions_bold'>Master’s Thesis:</strong>
                    <br/><br/>

                    Weisbaum LD. Human sexuality of children and adolescents: a comprehensive training guide for
                    social work professionals [master&#39;s thesis]. Long Beach (CA): California State University, Long
                    Beach; 2005. 101 p.

                </p>


                <h2 className='instructions_title'>
                    Tables
                </h2>

                <hr class="instructions_hr"/>

                <p className='instructions_p'>
                    Tables should be placed within the text and numbered. Please do not use vertical rules, while horizontal rules should be restricted to a minimum. Please do not use spaces to align columns in tables but use only one tab between each vertical column. The number of tables is limited to five.
                </p>

                <h2 className='instructions_title'>
                    Figures
                </h2>

                <hr class="instructions_hr"/>

                <p className='instructions_p'>
                    All illustrations should be provided electronically as separate graphic files (in GIF, TIF or JPEG format; 400 dpi) and embedded in the text of the manuscript. Please number the figures. Please provide illustrations in the size that you want to appear in the Journal. Legends for illustrations should be presented separately at the end of the manuscript and should be identified by number. The number of figures is limited to three.
                </p>


            </div>
        </div>
      </>
    );
}

export default Instructions;